export type Daypart = 'morning' | 'afternoon' | 'evening';

export function getDaypart(date: Date): Daypart {
  const hour = date.getHours();
  if (hour < 12) return 'morning';
  if (hour < 17) return 'afternoon';
  return 'evening';
}

export function getProfileGreeting(displayName: string, date = new Date()): string {
  return `Good ${getDaypart(date)}, ${displayName}`;
}
